import { store } from '@/app/store';
import type GlobalDataStorageRepositoryInterface from '../interface-adapters/GlobalDataStorageRepositoryInterface';
import {
    canFetchData,
    canNotFetchData,
    markAsFetchedData,
    setCustomerSourceId,
    setQrDiscountPercent,
    setCustomerInfo,
    setProducts,
    setIsLivestreamSessionExpired,
    setIsTooManyRequests,
    setIsFetchError,
} from '../redux/Slice';
import UserEntity from '@/app/features/user/entities/UserEntity';
import LivestreamProductEntity from '@/livestream/features/livestream-product/entities/LivestreamProductEntity';

export default class GlobalDataStorageRepository implements GlobalDataStorageRepositoryInterface {
    canFetchData(): void {
        store.dispatch(canFetchData());
    }

    canNotFetchData(): void {
        store.dispatch(canNotFetchData());
    }

    markAsFetchedData(): void {
        store.dispatch(markAsFetchedData());
    }

    setCustomerSourceId(customerSourceId: number | null): void {
        store.dispatch(setCustomerSourceId(customerSourceId));
    }

    setQrDiscountPercent(qrDiscountPercent: number): void {
        store.dispatch(setQrDiscountPercent(qrDiscountPercent));
    }

    setCustomerInfo(customerInfo: UserEntity | null): void {
        store.dispatch(setCustomerInfo(customerInfo));
    }

    setProducts(products: LivestreamProductEntity[]): void {
        store.dispatch(setProducts(products));
    }

    setIsLivestreamSessionExpired(isExpired: boolean): void {
        store.dispatch(setIsLivestreamSessionExpired(isExpired));
    }

    setIsTooManyRequests(isTooManyRequests: boolean): void {
        store.dispatch(setIsTooManyRequests(isTooManyRequests));
    }

    setIsFetchError(isFetchError: boolean): void {
        store.dispatch(setIsFetchError(isFetchError));
    }
}
